"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _detail = _interopRequireDefault(require("./detail.vue"));
var _sanjiang = require("@/api/sanjiang");
var _static = require("../static");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SjOilOrderList',
  components: {
    SjOilOrderDetail: _detail.default
  },
  data: function data() {
    return {
      listLoading: false,
      dataRange: [],
      detailVisible: false,
      currentOrderId: '',
      listPram: {
        page: 1,
        limit: 20,
        orderNo: '',
        // 交易订单号
        outTradeNo: '',
        // 商家订单号
        status: '',
        // 交易状态
        supplierId: '',
        // 商家ID
        storeId: '',
        // 门店ID
        phone: '',
        // 用户手机号
        startTime: '',
        endTime: ''
      },
      listData: {
        list: [],
        count: 0
      },
      // 交易状态选项 - 使用offsetStateOption
      transactionStatusOptions: _static.offsetStateOption,
      // 商家选项
      supplierOptions: [],
      supplierLoading: false,
      // 门店选项
      storeOptions: [],
      // 搜索防抖定时器
      searchTimer: null
    };
  },
  mounted: function mounted() {
    this.getList();
    this.loadSuppliers();
  },
  beforeDestroy: function beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  },
  methods: {
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.listLoading = true;
              _context.p = 1;
              // 处理时间范围
              if (this.dataRange && this.dataRange.length === 2) {
                this.listPram.startTime = this.dataRange[0];
                this.listPram.endTime = this.dataRange[1];
              } else {
                this.listPram.startTime = '';
                this.listPram.endTime = '';
              }
              _context.n = 2;
              return (0, _sanjiang.getStationOrderList)(this.listPram);
            case 2:
              response = _context.v;
              this.listData.list = response.list || [];
              this.listData.count = response.total || 0;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取订单列表失败:', _t);
              this.$message.error('获取订单列表失败');
              this.listData.list = [];
              this.listData.count = 0;
            case 4:
              _context.p = 4;
              this.listLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.getList();
    },
    // 导出订单
    exportOrders: function () {
      var _exportOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.$message.info('正在导出订单，请稍候...');

              // 处理时间范围
              params = _objectSpread({}, this.listPram); // 调用导出接口
              _context2.n = 1;
              return (0, _sanjiang.exportStationOrders)(params);
            case 1:
              res = _context2.v;
              console.log(res);
              if (res.fileName) {
                window.open(res.fileName);
                this.$message.success('导出成功');
              } else {
                this.$message.error('导出失败');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('导出订单失败:', _t2);
              this.$message.error('导出订单失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function exportOrders() {
        return _exportOrders.apply(this, arguments);
      }
      return exportOrders;
    }(),
    // 查看详情
    viewDetail: function viewDetail(row) {
      this.currentOrderId = row.orderNo;
      this.detailVisible = true;
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      var statusMap = {
        0: 'info',
        // 已取消
        1: 'primary',
        // 待支付
        2: 'success',
        // 已支付
        6: 'success',
        // 已完结
        7: 'warning',
        // 退款中
        8: 'danger',
        // 退款成功
        14: 'danger' // 部分退款
      };
      return statusMap[status] || 'info';
    },
    // 获取状态标签
    getStatusLabel: function getStatusLabel(status) {
      var statusOption = this.transactionStatusOptions.find(function (item) {
        return item.value === status;
      });
      return statusOption ? statusOption.label : '未知状态';
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.getList();
    },
    // 加载商家列表（页面初始化时调用）
    loadSuppliers: function () {
      var _loadSuppliers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.supplierLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _sanjiang.getSupplierList)({});
            case 2:
              res = _context3.v;
              this.supplierOptions = res || [];
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('加载商家列表失败:', _t3);
              this.supplierOptions = [];
            case 4:
              _context3.p = 4;
              this.supplierLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function loadSuppliers() {
        return _loadSuppliers.apply(this, arguments);
      }
      return loadSuppliers;
    }(),
    // 搜索商家（带防抖）
    searchSupplier: function searchSupplier(keyword) {
      var _this = this;
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      // 设置新的定时器，500ms后执行搜索
      this.searchTimer = setTimeout(function () {
        _this.performSupplierSearch(keyword);
      }, 500);
    },
    // 执行商家搜索
    performSupplierSearch: function () {
      var _performSupplierSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(keyword) {
        var res, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (keyword) {
                _context4.n = 1;
                break;
              }
              // 如果没有关键词，重新加载所有商家
              this.loadSuppliers();
              return _context4.a(2);
            case 1:
              this.supplierLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return (0, _sanjiang.getSupplierList)({
                keyword: keyword
              });
            case 3:
              res = _context4.v;
              this.supplierOptions = res || [];
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              console.error('搜索商家失败:', _t4);
              this.$message.error('搜索商家失败');
              this.supplierOptions = [];
            case 5:
              _context4.p = 5;
              this.supplierLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function performSupplierSearch(_x) {
        return _performSupplierSearch.apply(this, arguments);
      }
      return performSupplierSearch;
    }()
  }
};